export default __webpack_public_path__ + "static/media/115.042ce3ef.webp";